import { HttpErrorResponse } from '@angular/common/http';
import { ActionReducer, createFeature, createReducer, on } from '@ngrx/store';
import { ICIRuleAction } from 'src/app/shared/models/ci-rule-action.model';
import { CI_RULE_ACTIONS_API_ACTIONS } from '../actions/ci-rule-actions.actions';

export const CI_RULE_ACTIONS_STATE_KEY = 'ci-rule-actions';

export interface ICIRuleActionsState {
  data: ICIRuleAction[];
  loading: boolean;
  error: HttpErrorResponse | null;
}

export const ciRuleActionsInitialState: ICIRuleActionsState = {
  data: [],
  loading: false,
  error: null,
};

const reducer: ActionReducer<ICIRuleActionsState> = createReducer<ICIRuleActionsState>(
  ciRuleActionsInitialState,
  on(CI_RULE_ACTIONS_API_ACTIONS.get, (state) => ({
    ...state,
    loading: true,
  })),
  on(CI_RULE_ACTIONS_API_ACTIONS.success, (state, { data }) => ({
    ...state,
    loading: false,
    data,
  })),
  on(CI_RULE_ACTIONS_API_ACTIONS.error, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

export const CI_RULE_ACTIONS_REDUCER = createFeature({
  name: CI_RULE_ACTIONS_STATE_KEY,
  reducer,
});
